import {cancel} from '@sail/icons/react/Icon';
import {view, Icon, Divider, Link} from '@sail/ui';
import React from 'react';
import {useIntl} from '@sail/intl';
import {Button} from '../../SharedComponents/Button/Button';
import {UploadedFilePreview} from './FileUploaderFileListItem';
import {messages} from './messages';
import {styles} from './styles';

export const UploadedFileErrorState = ({
  disabled,
  fileName,
  retry,
  remove,
  showDivider,
  showPreview,
  uploadError,
}: {
  disabled?: boolean;
  fileName: string | null | undefined;
  retry: () => void;
  remove: () => void;
  showDivider: boolean;
  showPreview?: boolean;
  uploadError?: boolean;
}) => {
  const intl = useIntl();
  const errorMsg = uploadError
    ? messages.fileUploadFailure
    : messages.fileRetrieveFailure;
  return (
    <>
      <view.div uses={[styles.fileContainerRowStyles]}>
        {showPreview && <UploadedFilePreview />}
        <view.div uses={[styles.fileContainerColumnStyles]}>
          <view.div uses={[styles.fileNameContainerStyles]}>
            <view.span
              uses={[styles.fileNameStyles, styles.fileNameStylesUnprocessed]}
            >
              {fileName || intl.formatMessage(messages.uploadedFilePlaceholder)}
            </view.span>

            <view.div
              css={{
                stack: 'x',
                gap: 'medium',
                alignY: 'center',
                width: 'auto',
              }}
            >
              <Link onPress={retry}>
                {intl.formatMessage(messages.fileUploadRetry)}
              </Link>
              <Button
                onPress={remove}
                disabled={disabled}
                type="icon"
                aria-label={intl.formatMessage(messages.remove)}
              >
                <Icon
                  icon={cancel}
                  size="small"
                  css={{
                    color: 'action.secondary',
                    ':hover': {color: 'feedback.critical'},
                  }}
                />
              </Button>
            </view.div>
          </view.div>

          <view.span
            css={{
              font: 'body.small',
              color: 'feedback.critical',
            }}
          >
            {intl.formatMessage(errorMsg)}
          </view.span>
        </view.div>
      </view.div>
      {showDivider && <Divider uses={[styles.dividerStyles]} />}
    </>
  );
};
